import { get } from '@/utils/request'

// 获取左侧菜单
const menuApi = {
  buildMenus: function () {
    return get('menu/list', {})
  }
}

export default menuApi



// WEBPACK FOOTER //
// ./src/api/menu.js